export default {
  RESET_PASSWORD: {
    TITLE: 'Reset your password',
    SUBTITLE: 'You can reset your password using the form below.',
    BUTTON: 'Reset Password',
    SUCCESS_MESSAGE: 'Your password has been changed, please login.',
    ERROR_MESSAGE:
      'Failed to reset your password, please try again or contact our support.'
  }
}
